const MONK_BLOCK_SELECTOR =
  ".product-details .shopify-app-block[id*='monk_embedded_product_page_freegift_manual'], .product-details .shopify-app-block[id*='monk_embedded_product_page_any']";
const MONK_ROOT_SELECTOR = '#mr-div-embedded-prp-freegift_manual-page, #mr-div-embedded-prp-any-page';

/**
 * @param {HTMLElement} monkRootBlock
 * @returns {boolean}
 */
function hasContent(monkRootBlock) {
  return monkRootBlock.textContent.trim() !== '' || monkRootBlock.getBoundingClientRect().height > 0;
}

function updateMonkBlocks() {
  const blocks = document.querySelectorAll(MONK_BLOCK_SELECTOR);

  blocks.forEach((block) => {
    if (!(block instanceof HTMLElement)) return;

    const monkRootBlock = block.querySelector(MONK_ROOT_SELECTOR);

    if (!(monkRootBlock instanceof HTMLElement)) return;

    if (hasContent(monkRootBlock)) {
      block.style.removeProperty('display');
    } else {
      block.style.display = 'none';
    }
  });
}

function initMonkBlocks() {
  const container = document.querySelector('.product-details');
  if (!(container instanceof HTMLElement)) return;

  updateMonkBlocks();

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      updateMonkBlocks();
    });
  });

  observer.observe(container, { childList: true, subtree: true });
}

initMonkBlocks();
